import { useContext, useId, useState } from 'react'
import { observer } from 'mobx-react'
import { Icon } from '@/components/Generic'
import { StoreContext } from '@store/Root.store'
import { cx } from '@/utils/cx'
import { onKeyDownHandler } from '@/methods/keyboardAccessibility'
import type { HelpContent } from '@/types/dataCollection'
import { resolveLabel } from './helpers'

export const HelpSection = observer(({ help }: { help: HelpContent }) => {
  const { language } = useContext(StoreContext).TranslationsState
  const [open, setOpen] = useState(false)
  const bodyId = useId()

  const toggle = () => setOpen((prev) => !prev)

  return (
    <div className="data-collection__help">
      <div
        className={cx('data-collection__help-title', open && 'data-collection__help-title--open')}
        role="button"
        tabIndex={0}
        aria-expanded={open}
        aria-controls={bodyId}
        onClick={toggle}
        onKeyDown={(event) => onKeyDownHandler(event, toggle)}
      >
        <Icon
          type="questionmark-circle"
          size="20px"
          color="var(--data-collection-icon-color, #76be74)"
        />
        <span className="data-collection__help-title-text">
          {resolveLabel(help.title, language)}
        </span>
        <Icon type={open ? 'caret-up' : 'caret-down'} size="16px" />
      </div>
      <div
        id={bodyId}
        className={cx('data-collection__help-body', open && 'data-collection__help-body--open')}
        aria-hidden={!open}
      >
        {resolveLabel(help.text, language)}
      </div>
    </div>
  )
})
